import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    enabledLicensesModules,
    getEnabledLicensesModulesProgress,
    stopEnabledLicensesModulesAction,
} from 'src/openapi/admin/apis/BulkLicensesModulesApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {EnableModuleLicenseModal} from './license-access-module-enable.modal';
import {
    selectLicenseAccessModuleEnableResultTask,
    selectLicenseAccessModuleEnableResultUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from './license-access-module-enable.slice';

import type {LicenseBulkUpdateRequest} from 'src/openapi/admin/models/LicenseBulkUpdateRequest';

type Props = {
    shown: boolean,
    accountIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const LicenseAccessModuleEnableTool = ({shown, accountIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<LicenseBulkUpdateRequest>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectLicenseAccessModuleEnableResultTask}
            uuidSelector={selectLicenseAccessModuleEnableResultUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(licenseBulkUpdateRequest, options) => (
                apiDispatch(enabledLicensesModules({...options, licenseBulkUpdateRequest}))
            )}
            getProgress={id => apiDispatch(getEnabledLicensesModulesProgress({id}))}
            stopAction={id => apiDispatch(stopEnabledLicensesModulesAction({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <EnableModuleLicenseModal {...{accountIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
